<div class="page-layout carded fullwidth">
  <div class="center px-56">
    <div class="header">
      <span class="h1" *ngIf="filterService.selectedForm?.name">{{ filterService.selectedForm.name }}</span>
      <span class="h1" *ngIf="!filterService.selectedForm?.name">{{ 'DASHBOARD_FORMS.TITLE' | translate }}</span>

      <div class="page-buttons">
        <button
          *ngIf="filterService.selectedForm && filterService.selectedForm.id && hasCreateExportPermission"
          [disabled]="!filterService.questionsCount"
          mat-stroked-button
          [matTooltip]="'DASHBOARD_FORMS.DETAIL.EXPORT' | translate"
          [matTooltipPosition]="'left'"
          (click)="exportFormAnswers()"
        >
          <i class="angularjs-fuse-icon icon-file-excel"></i>
        </button>

        <button
          mat-stroked-button
          labelPosition="before"
          (click)="filterService.reload()"
          [matTooltip]="'DASHBOARD_FORMS.RELOAD' | translate"
        >
          <i class="angularjs-fuse-icon icon-reload small"></i>
        </button>

        <button
          [hidden]="!filterService.isFilterOn"
          mat-stroked-button
          [matTooltip]="'DASHBOARD_FORMS.FILTERS.CLEAR' | translate"
          (click)="filterService.clearFilters()"
        >
          <i class="angularjs-fuse-icon icon-filter-remove"></i>
        </button>
      </div>
    </div>

    <div class="formsReport">
      <div class="row">
        <div class="formsReport__card">
          <forms-report-filter></forms-report-filter>
        </div>
      </div>
      <div>
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
